module.exports = __webpack_public_path__ + "static/media/120_Maj_UM0074_processesd_rsz.ef13676c.jpg";